import { Accordion, styled } from '@mui/material';

export const StyledAccordion = styled(Accordion)`
  background-color: transparent;
  border: none;
`;
